<template>
    <div class="clearfix main_center" v-loading.fullscreen.lock="loading">

        <div class="right-content">
            <el-form ref="form" :model="form" label-width="180px">
                <el-card class="box-card">
                    <div slot="header" class="clearfix">
                        <span>进场项目信息</span>
                    </div>
                    <div class="form-content default-content">
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="所属区域：" size="small">
                                    {{ form.regionId | regionFilter }}
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="招标（采购）项目名称：" size="small">
                                    {{ form.projectName }}
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="招标（采购）人：" size="small">
                                    {{ form.tendererName }}
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="24">
                                <el-form-item label="招标（采购）项目内容：" size="small">
                                    {{ form.tenderContent }}
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="预算金额：" size="small">
                                    {{ form.budgetAmount }} &nbsp;&nbsp;万元
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="资金来源：" size="small">
                                    {{ form.fundSource }}
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="是否评定分离：" size="small">
                                    {{ form.isSeparate === '1' ? '是' : '否' }}
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="是否远程异地：" size="small">
                                    {{ form.isRemote === '1' ? '是' : '否' }}
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="招标（采购）联系人：" size="small">
                                    {{ form.tendererContact }}
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="联系方式：" size="small">
                                    {{ form.tendererPhone }}
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="招标（采购）代理联系人：" size="small">
                                    {{ form.agentContact }}
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="联系方式：" size="small">
                                    {{ form.agentPhone }}
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </div>
                </el-card>
                <el-card class="box-card">
                    <div slot="header" class="clearfix">
                        <span>附件信息</span>
                    </div>
                    <template>
                        <div class="affixDown" v-if="form.attachments.length > 0" style="margin-bottom: 10px">
                            <affixDoc
                                v-for="(item, index) in form.attachments"
                                :item.sync="item"
                                labelWidth="224px"
                                :index="index"
                                :key="index"
                                :showModal="false"
                                name="相关附件"
                            >
                            </affixDoc>
                        </div>
                        <p style="text-align: center" v-if="form.attachments.length === 0">暂无附件数据</p>
                    </template>
                </el-card>
                <el-card class="box-card" v-if="canFillData.level1">
                    <div slot="header" class="clearfix">
                        <span>业务协调部受理</span>
                    </div>
                    <div class="form-content default-content">
                        <el-form :model="approvalRecordForm" :rules="approvalRecordRules" ref="approvalRecordFormRef" label-width="180px">
                            <el-row>
                                <el-col :span="24">
                                    <el-form-item label="拟承接部门：" size="small" prop="department">
                                        <el-select v-model="approvalRecordForm.department" placeholder="请选择">
                                            <el-option
                                                v-for="item in departmentOptions"
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item.value">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="24">
                                    <el-form-item label="受理意见：" size="small" prop="acceptOpinion">
                                        <el-input type="textarea"
                                                  v-model="approvalRecordForm.acceptOpinion"
                                                  placeholder="请输入"
                                                  :rows="5"
                                                  maxlength="500"
                                                  show-word-limit
                                        />
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="12">
                                    <el-form-item label="经办人：" size="small" prop="handler">
                                        <el-input v-model="approvalRecordForm.handler" placeholder="请输入" />
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </el-form>
                    </div>
                </el-card>
                <el-card class="box-card" v-else-if="form.approvalRecord">
                    <div slot="header" class="clearfix">
                        <span>业务协调部受理</span>
                    </div>
                    <div class="form-content default-content">
                        <el-row>
                            <el-col :span="24">
                                <el-form-item label="拟承接部门：" size="small">
                                    {{ form.approvalRecord.department | undertakeDeptFilter }}
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="24">
                                <el-form-item label="受理意见：" size="small">
                                    {{ form.approvalRecord.acceptOpinion }}
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="经办人：" size="small">
                                    {{ form.approvalRecord.handler }}
                                </el-form-item>
                            </el-col>
                            <el-col :span="12" v-if="flowNodeLength != 12">
                                <el-form v-if="canFillData.level12" :model="approvalRecordForm" :rules="approvalRecordRules" ref="approvalRecordFormRef" label-width="180px">
                                    <el-form-item  label="负责人：" size="small" prop="leader">
                                        <el-input v-model="approvalRecordForm.leader" placeholder="请输入负责人" />
                                    </el-form-item>
                                </el-form>
                                <el-form-item v-else label="负责人：" size="small">
                                    {{ form.approvalRecord.leader }}
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </div>
                </el-card>
                <el-card class="box-card" v-if="canFillData.level2">
                    <div slot="header" class="clearfix">
                        <span>业务部室办理</span>
                    </div>
                    <div class="form-content default-content">
                        <el-form :model="approvalOpinionYctbForm" :rules="approvalOpinionYctbRules" ref="approvalOpinionYctbFormRef" label-width="180px">
                            <el-row>
                                <el-col :span="24">
                                    <el-form-item label="办理意见：" size="small" prop="handleOpinion">
                                        <el-input type="textarea"
                                                  v-model="approvalOpinionYctbForm.handleOpinion"
                                                  placeholder="请输入"
                                                  :rows="5"
                                                  maxlength="500"
                                                  show-word-limit
                                        />
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row v-if="form.approvalRecord.department === 2">
                                <el-col :span="24">
                                    <el-form-item label="采购类别：" size="small" prop="purchaseType">
                                        <el-radio-group v-model="approvalOpinionYctbForm.purchaseType">
                                            <el-radio :label="1">集中采购</el-radio>
                                            <el-radio :label="2">分散采购</el-radio>
                                            <el-radio :label="3">企业采购</el-radio>
                                        </el-radio-group>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="12">
                                    <el-form-item label="经办人：" size="small" prop="handler">
                                        <el-input v-model="approvalOpinionYctbForm.handler" placeholder="请输入" />
                                    </el-form-item>
                                </el-col>
                            </el-row>
                           <el-row v-if="flowNodeLength == 12">
                               <el-col :span="24">
                                 <el-form-item label="进场交易项目流程表：" size="small">
                                   <div class="attachment">
                                     <p class="name">{{ approvalOpinionYctbForm.fileName }}</p>
                                     <div class="actions">
                                       <el-button
                                           type="primary" plain
                                           :loading="creatFileLoading"
                                           @click="onClickCreateFile3"
                                       >生成</el-button>
                                       <el-button v-if="approvalOpinionYctbForm.filePath"
                                                  type="primary" plain
                                                  @click="onClickFileView(approvalOpinionYctbForm.filePath)"
                                       >预览</el-button>
                                     </div>
                                   </div>
                                 </el-form-item>
                               </el-col>
                           </el-row>
                        </el-form>
                    </div>
                </el-card>
                <el-card class="box-card" v-else-if="form.approvalOpinionYctb">
                    <div slot="header" class="clearfix">
                        <span>业务部室办理</span>
                    </div>
                    <div class="form-content default-content">
                        <el-row>
                            <el-col :span="24">
                                <el-form-item label="办理意见：" size="small">
                                    {{ form.approvalOpinionYctb.handleOpinion }}
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row v-if="form.approvalRecord.department === 2">
                            <el-col :span="24">
                                <el-form-item label="采购类别：" size="small">
                                    <el-radio-group v-model="form.approvalOpinionYctb.purchaseType" disabled>
                                        <el-radio :label="1">集中采购</el-radio>
                                        <el-radio :label="2">分散采购</el-radio>
                                        <el-radio :label="3">企业采购</el-radio>
                                    </el-radio-group>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="经办人：" size="small">
                                    {{ form.approvalOpinionYctb.handler }}
                                </el-form-item>
                            </el-col>
                            <el-col :span="12" v-if="flowNodeLength != 12">
                                <el-form v-if="canFillData.level22" :model="approvalOpinionYctbForm" :rules="approvalOpinionYctbRules" ref="approvalOpinionYctbFormRef" label-width="180px">
                                    <el-form-item  label="负责人：" size="small" prop="leader">
                                        <el-input v-model="approvalOpinionYctbForm.leader" placeholder="请输入负责人" />
                                    </el-form-item>
                                </el-form>
                                <el-form-item v-else label="负责人：" size="small">
                                    {{ form.approvalOpinionYctb.leader }}
                                </el-form-item>
                            </el-col>
                            <el-col :span="24" v-if="flowNodeLength == 20">
                              <el-form-item label="进场交易项目流程表：" size="small">
                                <div class="attachment">
                                  <p class="name">{{ form.approvalOpinionYctb.fileName }}</p>
                                  <div class="actions">
                                    <el-button
                                        type="primary" plain
                                        v-if="canFillData.level22"
                                        :loading="creatFileLoading"
                                        @click="onClickCreateFile2"
                                    >生成</el-button>
                                    <el-button v-if="form.approvalOpinionYctb.filePath"
                                               type="primary" plain
                                               @click="onClickFileView(form.approvalOpinionYctb.filePath)"
                                    >预览</el-button>
                                  </div>
                                </div>
                              </el-form-item>
                            </el-col>
                        </el-row>
                    </div>
                </el-card>
                <el-card class="box-card" v-if="canFillData.level3">
                    <div slot="header" class="clearfix">
                        <span>业务协调部受理情况登记</span>
                    </div>
                    <div class="form-content default-content">
                        <el-form :model="acceptanceRecordYctbForm" :rules="acceptanceRecordYctbRules" ref="acceptanceRecordYctbFormRef" label-width="180px">
                            <el-row>
                                <el-col :span="24">
                                    <el-form-item label="受理情况：" size="small" prop="acceptanceContent">
                                        <el-input type="textarea"
                                                  v-model="acceptanceRecordYctbForm.acceptanceContent"
                                                  placeholder="请输入"
                                                  :rows="5"
                                                  maxlength="500"
                                                  show-word-limit
                                        />
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="12">
                                    <el-form-item label="记录人：" size="small" prop="applicantName">
                                        <el-input v-model="acceptanceRecordYctbForm.applicantName" placeholder="请输入" />
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </el-form>
                        <el-row>
                            <el-col :span="24">
                                <el-form-item label="进场交易项目流程表：" size="small">
                                    <div class="attachment">
                                        <p class="name">{{ acceptanceRecordYctbForm.fileName }}</p>
                                        <div class="actions">
                                            <el-button
                                                type="primary" plain
                                                :loading="creatFileLoading"
                                                @click="onClickCreateFile"
                                            >生成</el-button>
                                            <el-button v-if="acceptanceRecordYctbForm.filePath"
                                                       type="primary" plain
                                                       @click="onClickFileView(acceptanceRecordYctbForm.filePath)"
                                            >预览</el-button>
                                        </div>
                                    </div>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </div>
                </el-card>
                <el-card class="box-card" v-else-if="form.acceptanceRecordYctb">
                    <div slot="header" class="clearfix">
                        <span>业务协调部受理情况登记</span>
                    </div>
                    <div class="form-content default-content">
                        <el-row>
                            <el-col :span="24">
                                <el-form-item label="受理情况：" size="small">
                                    {{ form.acceptanceRecordYctb.acceptanceContent }}
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="24">
                                <el-form-item label="记录人：" size="small">
                                    {{ form.acceptanceRecordYctb.applicantName }}
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="24">
                                <el-form-item label="进场交易项目流程表：" size="small">
                                    <div class="attachment">
                                        <p class="name">{{ form.acceptanceRecordYctb.fileName }}</p>
                                        <div class="actions">
                                            <el-button v-if="form.acceptanceRecordYctb.filePath"
                                                       type="primary" plain
                                                       @click="onClickFileView(form.acceptanceRecordYctb.filePath)"
                                            >预览</el-button>
                                        </div>
                                    </div>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </div>
                </el-card>
                <el-card class="box-card" style="margin-bottom:10px" v-if="auditHisTable && auditHisTable.length > 0">
                    <div slot="header" class="clearfix">
                        <span>工作流</span>
                    </div>
                    <el-table
                        :data="auditHisTable"
                        stripe
                        border
                        style="width: 100%;">
                        <el-table-column
                            type="index"
                            header-align="center"
                            align="center"
                            label="序号"
                            width="80">
                        </el-table-column>
                        <el-table-column
                            prop="taskName"
                            align="left"
                            :show-overflow-tooltip="true"
                            width="200"
                            label="步骤"  >
                        </el-table-column>
                        <el-table-column
                            prop="userName"
                            align="left"
                            :show-overflow-tooltip="true"
                            width="250"
                            label="办理人员"  >
                        </el-table-column>
                        <el-table-column
                            prop="excuteDate"
                            align="center"
                            width="250"
                            label="处理时间">
                        </el-table-column>
                        <el-table-column
                            prop="auditMsg"
                            align="left"
                            :show-overflow-tooltip="true"
                            label="描述/意见"
                        >
                           <template slot-scope="scope">
                               {{ scope.row.auditMsg==="null" ? "请审批" : scope.row.auditMsg }}
                           </template>
                        </el-table-column>
                    </el-table>
                </el-card>
            </el-form>
        </div>
        <div class="left-content">
            <div class="left-navbar">
                <el-button v-if="filingCBtn"
                           type="primary"
                           size="small"
                           @click="showAuditWindow(true, '同意')"
                >同意</el-button>
                <el-button v-if="backCBtn"
                           type="primary"
                           plain
                           size="small"
                           @click="showAuditWindow(false, '')"
                >退回</el-button>
                <el-button size="small" @click="backBtn">返回</el-button>
            </div>
        </div>
        <el-dialog title="意见栏" :visible.sync="dialogVisible" width="40%">
            <div class="dialogBox">
                <el-form ref="auditForm" :model="auditForm" label-width="90px" class="form">
                    <el-form-item label="意见：" style="width:90%;">
                        <el-input type="textarea" :rows="10" v-model="auditForm.suggest"></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false" class="backBtn">返回</el-button>
                <el-button type="primary" @click="onClickApprove" style="margin-bottom:20px;">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import {tabsCloseCurrentHandle} from '@/utils/routeTab';
import affixDoc from "@/components/affixDoc";

export default {
    components: {
        affixDoc
    },
    data() {
        return {
            form: {
                attachments: []
            },
            filingCBtn: false, //同意按钮
            backCBtn: false, //退回按钮
            dialogVisible: false, //展示意见弹窗
            auditForm: { //展示意见弹窗表单
                isPass: null,
                suggest: ''
            },
            loading: false,
            canFillData: {}, //各级是否可以操作
            departmentOptions: [
                {
                    value: 1,
                    label: '工程建设部'
                },
                {
                    value: 2,
                    label: '政府采购部'
                },
                {
                    value: 3,
                    label: '资源与产权交易部'
                }
            ],
            approvalRecordForm: {},
            approvalRecordRules: {
                department: [{required: true, message: '请选择拟承接部门', trigger: 'blur'}],
                handler: [{required: true, message: '请输入经办人', trigger: 'blur'}],
                acceptOpinion: [{required: true, message: '请输入受理意见', trigger: 'blur'}],
                leader: [{required: true, message: '请输入负责人', trigger: 'blur'}],
            },
            approvalOpinionYctbForm: {},
            approvalOpinionYctbRules: {
                purchaseType: [{required: true, message: '请选择采购类别', trigger: 'blur'}],
                handleOpinion: [{required: true, message: '请输入受理意见', trigger: 'blur'}],
                handler: [{required: true, message: '请输入经办人', trigger: 'blur'}],
                leader: [{required: true, message: '请输入负责人', trigger: 'blur'}],
            },
            acceptanceRecordYctbForm: {
                fileName: '',
                filePath: ''
            },
            acceptanceRecordYctbRules: {
                applicantName: [{required: true, message: '请输入记录人', trigger: 'blur'}],
                acceptanceContent: [{required: true, message: '请输入受理情况', trigger: 'blur'}],
            },
            creatFileLoading: false, //生成按钮loading
            pdfViewer:'/pdf/web/viewer.html?file=',
            auditHisTable: [], //监督记录表格数据
            flowNodeLength:0,//  26条数据-5级审批 20条数据-4级审批， 12条数据-2级审批
        }
    },
    filters: {
        regionFilter(regionId) {
            const map = {
                421200: '咸宁市',
                421201: '咸宁市本级',
                421202: '咸安区',
                421221: '嘉鱼县',
                421222: '通城县',
                421223: '崇阳县',
                421224: '通山县',
                421281: '赤壁市',
            }
            return map[regionId] || ''
        },
        undertakeDeptFilter(status) {
            //1 工程建设部 2 政府采购部 3 资源与产权交易部
            switch (status) {
                case 1:
                    return '工程建设部';
                case 2:
                    return '政府采购部';
                case 3:
                    return '资源与产权交易部';
                default:
                    return '';
            }
        },
    },
    activated() {
        this.id = this.$route.query.id;
        this.requestDetailData();
    },
    mounted() {
        this.pdfViewer = this.$http.adornUrl(this.pdfViewer);
    },
    methods: {
        //获取详情数据
        requestDetailData() {
            this.$http.get(`/projectEntry/get?projectEntryRegisterId=${this.id}`).then(({data}) => {
                if (data.code === '1') {
                    this.form = {...data.data}
                    this.approvalRecordForm = data.data.approvalRecord?{...data.data.approvalRecord}:{},
                    this.approvalOpinionYctbForm = data.data.approvalOpinionYctb?{...data.data.approvalOpinionYctb}:{}
                    this.acceptanceRecordYctbForm = data.data.acceptanceRecordYctb?{...data.data.acceptanceRecordYctb}:{}
                    this.getFlow()
                    this.getIsCanFill()
                }
            })
        },
        //获取流程
        getFlow() {
            this.$http.get(`/workflow/getInfo?processInstanceid=${this.form.processinstanceid}`).then(res => {
                if (res.data.data.taskId !== '') {
                    this.taskId = res.data.data.taskId;
                    res.data.data.buttons.forEach(item => {
                        if (item.type === 1) {
                            this.processSubmit = true;
                        }
                        if (item.type === 2) {
                            this.filingCBtn = true
                        }
                        if (item.type === 3) {
                            this.backCBtn = true
                        }
                        if (item.type === 10) {
                            this.backCBtn = true
                            this.filingCBtn = true
                        }
                    })
                    this.auditHisTable = res.data.data.auditHistorys || [];
                    this.flowNodeLength = res.data.data.flowelements?.length || 0;
                }
            })
        },
        //判断当前节点是否能填写
        getIsCanFill() {
            this.$http.get(`/projectEntry/isCanFill?processInstanceid=${this.form.processinstanceid}`).then(({data}) => {
                if (data.code === '1') {
                    this.canFillData = data.data;
                }
            })
        },
        getRowsIndex(index) {
            return index + 1
        },
        backBtn() { //返回
            tabsCloseCurrentHandle();
            this.$router.push({
                name: 'singleWindowServiceProjectList'
            })
            this.$refs.form.resetFields();
        },
        //展示意见
        showAuditWindow(isPass, msg) {
            if(isPass) {
                this.handleApprovalFormValidate(() => {
                    this.dialogVisible = true;
                    this.auditForm.suggest = msg;
                    this.auditForm.isPass = isPass;
                })
            }else {
                this.dialogVisible = true;
                this.auditForm.suggest = msg;
                this.auditForm.isPass = isPass;
            }
        },
        //审批表单校验
        handleApprovalFormValidate(callback) {
            if(this.canFillData.level1 || this.canFillData.level12){
                this.$refs.approvalRecordFormRef.validate((valid) => {
                    if (valid) {
                        callback && callback()
                    }
                })
            }else if(this.canFillData.level2 || this.canFillData.level22){
                this.$refs.approvalOpinionYctbFormRef.validate((valid) => {
                    if (valid) {
                      if(this.canFillData.level2 && this.flowNodeLength == 12 && !this.approvalOpinionYctbForm.filePath){
                        this.$message.error('请先生成进场交易项目流程表')
                      }else if(this.canFillData.level22 && !this.form.approvalOpinionYctb.filePath && this.flowNodeLength == 20){
                        this.$message.error('请先生成进场交易项目流程表')
                      }else{
                        callback && callback()
                      }
                    }
                })
            }else if(this.canFillData.level3){
                this.$refs.acceptanceRecordYctbFormRef.validate((valid) => {
                    if (valid) {
                        if(!this.acceptanceRecordYctbForm.filePath) {
                            this.$message.error('请先生成进场交易项目流程表')
                        }else {
                            callback && callback()
                        }
                    }
                })
            }else{
              callback && callback()
            }
        },
        //审批
        onClickApprove() {
            if(!this.auditForm.suggest) {
                this.$message.error('请输入审批意见')
                this.$nextTick(() => { //为了解决被dialog遮挡的问题
                    const messages = document.querySelectorAll('.el-message');
                    messages.forEach(message => {
                        message.style.zIndex = 9999;
                    });
                });
                return
            }
            if(this.canFillData.level1){ //业务协调部一审提交数据
                const params = {
                    approvalRecord: {
                        ...this.approvalRecordForm,
                        projectId: this.id,
                    }
                }
                this.requestApprove(params)
            }else if(this.canFillData.level12){ //业务协调部二审提交数据
                const params = {
                    approvalRecord: {
                        ...this.approvalRecordForm,
                        projectId: this.id,
                        department: this.form.approvalRecord.department,
                        handler: this.form.approvalRecord.handler,
                        acceptOpinion: this.form.approvalRecord.acceptOpinion,
                        id: this.form.approvalRecord.id,
                    }
                }
                this.requestApprove(params)
            }else if(this.canFillData.level2){ //业务部室一审提交数据
                const params = {
                    approvalOpinionYctb: {
                        ...this.approvalOpinionYctbForm,
                        projectId: this.id,
                        filePath: this.approvalOpinionYctbForm.filePath || '',
                        fileName: this.approvalOpinionYctbForm.fileName || '',
                    }
                }
                this.requestApprove(params)
            }else if(this.canFillData.level22){ //业务部室二审提交数据
                const params = {
                    approvalOpinionYctb: {
                        ...this.approvalOpinionYctbForm,
                        projectId: this.id,
                        handleOpinion: this.form.approvalOpinionYctb.handleOpinion,
                        purchaseType: this.form.approvalOpinionYctb.purchaseType,
                        handler: this.form.approvalOpinionYctb.handler,
                        id: this.form.approvalOpinionYctb.id,
                        filePath: this.form.approvalOpinionYctb.filePath || '',
                        fileName: this.form.approvalOpinionYctb.fileName || '',
                    }
                }
                this.requestApprove(params)
            }else if(this.canFillData.level3){ //业务协调部最后审批提交数据
                const params = {
                    acceptanceRecordYctb: {
                        ...this.acceptanceRecordYctbForm,
                        projectId: this.id,
                    }
                }
                this.requestApprove(params)
            }else{
                const params = {
                  approvalRecord: {
                    projectId: this.id,
                  }
                }
                this.requestApprove(params)
            }
        },
        requestApprove(approveData) {
            const params = {
                id: this.id,
                taskId: this.taskId,
                processinstanceid: this.form.processinstanceid,
                variables: {
                    commit: this.auditForm.isPass,
                    opinion: this.auditForm.suggest //见证意见
                },
                ...approveData
            }
            this.loading = true;
            this.$http.post('/projectEntry/approve', params).then(({data}) => {
                this.loading = false;
                this.dialogVisible = false;
                if (data.code === '1') {
                    this.$message.success('操作成功')
                    setTimeout(() => {
                        this.backBtn()
                    }, 500)
                } else {
                    this.$message.error(data.msg)
                }
            })
        },
      //生成进场交易项目流程表3
      onClickCreateFile3(){
        this.$refs.approvalOpinionYctbFormRef.validate((valid) => {
          if (valid) {
            this.creatFileLoading = true
            const params = {
              id: this.id,
              flowNodeLength: this.flowNodeLength,
              processinstanceid: this.form.processinstanceid,
              approvalOpinionYctb: {
                projectId: this.id,
                handler:this.approvalOpinionYctbForm.handler,
                handleOpinion:this.approvalOpinionYctbForm.handleOpinion,
                ...this.form.approvalOpinionYctbForm
              }
            }
            this.$http.post('/projectEntry/createPdf', params).then(({data}) => {
              if (data.code === '1') {
                this.$message.success('操作成功')
                this.approvalOpinionYctbForm.fileName = data.data.name
                this.approvalOpinionYctbForm.filePath = data.data.filePath
              } else {
                this.$message.error(data.msg)
              }
            }).finally(() => {
              this.creatFileLoading = false
            })
          }
        })
      },
      //生成进场交易项目流程表
      onClickCreateFile2(){
        this.$refs.approvalOpinionYctbFormRef.validate((valid) => {
          if (valid) {
            this.creatFileLoading = true
            const params = {
              id: this.id,
              flowNodeLength: this.flowNodeLength,
              processinstanceid: this.form.processinstanceid,
              approvalOpinionYctb: {
                projectId: this.id,
                leader:this.approvalOpinionYctbForm.leader,
                ...this.form.approvalOpinionYctb
              }
            }
            this.$http.post('/projectEntry/createPdf', params).then(({data}) => {
              if (data.code === '1') {
                this.$message.success('操作成功')
                this.form.approvalOpinionYctb.fileName = data.data.name
                this.form.approvalOpinionYctb.filePath = data.data.filePath
              } else {
                this.$message.error(data.msg)
              }
            }).finally(() => {
              this.creatFileLoading = false
            })
          }
        })
      },
        //生成进场交易项目流程表
        onClickCreateFile(){
            this.$refs.acceptanceRecordYctbFormRef.validate((valid) => {
                if (valid) {
                    this.creatFileLoading = true
                    const params = {
                        id: this.id,
                        processinstanceid: this.form.processinstanceid,
                        flowNodeLength: this.flowNodeLength,
                        acceptanceRecordYctb: {
                            projectId: this.id,
                            acceptanceContent: this.acceptanceRecordYctbForm.acceptanceContent,
                            applicantName: this.acceptanceRecordYctbForm.applicantName,
                        }
                    }
                    this.$http.post('/projectEntry/createPdf', params).then(({data}) => {
                        if (data.code === '1') {
                            this.$message.success('操作成功')
                            this.acceptanceRecordYctbForm.fileName = data.data.name
                            this.acceptanceRecordYctbForm.filePath = data.data.filePath
                        } else {
                            this.$message.error(data.msg)
                        }
                    }).finally(() => {
                        this.creatFileLoading = false
                    })
                }
            })
        },
        onClickFileView(filePath){
            if(filePath){
                window.open(this.pdfViewer + filePath, '_blank')
            }
        },
        // 获取监督记录
        getAuditHisList(){
            // 查询监督记录数据
            if(this.id){
                this.$http.get('/auditHistory/getListAudit?entityId='+this.id).then(res=>{
                    if(res.data.code==='1'){
                        this.auditHisTable = res.data.data;
                    }else{
                        this.auditHisTable = [];
                        this.$message({
                            type:'error',
                            message:res.data.msg
                        })
                    }
                })
            }else{
                this.auditHisTable = [];
            }

        },
    }


}
</script>

<style lang="less" scoped>
.angle_tag {
    margin-right: 10px !important;
}

.attachment{
    .name {
        line-height: 40px;
        height: 40px;
        border-bottom: 1px solid #ebeef5;
    }
    .actions {
        position: absolute;
        right: 20px;
        top: -1px;
    }
}
</style>
